import { useCallback, useEffect, useState } from "react";

export function useSpeech() {
  const [enabled, setEnabled] = useState(() => localStorage.getItem("psh_tts") === "1");
  const [speaking, setSpeaking] = useState(false);
  const supported = typeof window !== "undefined" && !!window.speechSynthesis;

  const stop = useCallback(() => {
    if (supported) window.speechSynthesis.cancel();
    setSpeaking(false);
  }, [supported]);

  const speak = useCallback(
    (text) => {
      if (!supported || !text) return;
      window.speechSynthesis.cancel();
      const clean = text.replace(/[*_#`>]/g, "").replace(/\s+/g, " ").trim();
      const utterance = new SpeechSynthesisUtterance(clean);
      utterance.rate = 1.02;
      utterance.onend = () => setSpeaking(false);
      utterance.onerror = () => setSpeaking(false);
      setSpeaking(true);
      window.speechSynthesis.speak(utterance);
    },
    [supported]
  );

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev;
      localStorage.setItem("psh_tts", next ? "1" : "0");
      if (!next) stop();
      return next;
    });
  }, [stop]);

  useEffect(() => stop, [stop]);

  return { enabled, toggle, speak, stop, speaking, supported };
}
